// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  COLLECTIONS_LABELS,
  collectionsLabels,
} from '@tcp/core/src/utils/labels/browse/Bundle.labels';
import {
  EntryBlockWrapper,
  TextWrapper,
  StyledButton,
} from '../styles/BuildYourExperienceEntryBlock.style';
import { sendClickEvent } from '../../../utils/BundleProduct.analytics';

const BuildYourExperienceEntryBlock = ({
  className,
  setBuildYourExperienceState,
  fullWidth,
  isCollectionsZoomEnabled,
}) => {
  const collectionsLabelsObj = getLabelFromCopyOrFromTranslation(
    COLLECTIONS_LABELS,
    collectionsLabels
  );

  const headerLabel = renderLabel(
    collectionsLabelsObj.lbl_build_your_experience_entry_header,
    'lbl_build_your_experience_entry_header'
  );
  const bodyLabel = renderLabel(
    collectionsLabelsObj.lbl_build_your_experience_entry_body,
    'lbl_build_your_experience_entry_body'
  );
  const ctaLabel = renderLabel(
    collectionsLabelsObj.lbl_build_your_experience_entry_cta,
    'lbl_build_your_experience_entry_cta'
  );

  const onClick = () => {
    setTimeout(() => {
      setBuildYourExperienceState(true);
      const productDetailsSection = document.querySelector('#productDetailsSection');
      if (productDetailsSection) {
        productDetailsSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      sendClickEvent({ name: ctaLabel, buttonName: ctaLabel });
    }, 0);
  };

  return (
    <EntryBlockWrapper
      className={className}
      fullWidth={fullWidth}
      isCollectionsZoomEnabled={isCollectionsZoomEnabled}
    >
      <TextWrapper className="build-your-experience-text-wrapper">
        <BodyCopy
          fontFamily="secondary"
          fontSize="fs16"
          fontWeight="bold"
          className="build-your-experience-header"
        >
          {headerLabel}
        </BodyCopy>
        <BodyCopy fontFamily="secondary" fontSize="fs14" className="build-your-experience-body">
          {bodyLabel}
        </BodyCopy>
      </TextWrapper>
      <StyledButton className="build-your-experience-button" onClick={onClick}>
        {ctaLabel}
      </StyledButton>
    </EntryBlockWrapper>
  );
};

BuildYourExperienceEntryBlock.propTypes = {
  className: PropTypes.string.isRequired,
  setBuildYourExperienceState: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool.isRequired,
  isCollectionsZoomEnabled: PropTypes.bool.isRequired,
};

export default BuildYourExperienceEntryBlock;
